import { crossIcon } from '@porterin/feature/src/ui/assets/AssetStore';
import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import React, { useEffect, useRef } from 'react';

import {
  confirmation_modal_subtitle,
  confirmation_modal_title,
} from '../../domain/store/PnMStoreEn';
import styles from '../styles/PnMCallbackConfirmation.module.scss';

import { successImgUrl } from './payment-success/store/PaymentSuccessStore';

const AUTO_CLOSE_TIMEOUT_MS = 3000;

interface PnMCallbackConfirmationCmpProps {
  close_modal: () => void;
}

function PnMCallbackConfirmationCmp({
  close_modal,
}: Readonly<PnMCallbackConfirmationCmpProps>): React.ReactElement {
  const closeModalRef = useRef(close_modal);
  closeModalRef.current = close_modal;

  useEffect(() => {
    const timer = setTimeout(() => {
      closeModalRef.current();
    }, AUTO_CLOSE_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={styles['pnm-callback-confirmation-container']}>
      <button className={styles['close-modal-button']} onClick={close_modal}>
        <NextImageV2
          src={crossIcon}
          height={24}
          width={24}
          alt="close"
          quality={100}
        />
      </button>
      <div className={styles['title']}>{confirmation_modal_title}</div>
      <div className={styles['success-icon']}>
        <NextImageV2
          src={successImgUrl}
          height={128}
          width={128}
          alt="success icon"
          quality={100}
        />
      </div>
      <div className={styles['sub-title']}>{confirmation_modal_subtitle}</div>
    </div>
  );
}

export default PnMCallbackConfirmationCmp;
